import { z } from 'zod';

import zodLocales from 'common/zod/locales';

import { locales } from './locales';

export const revenueSituationSchema = z
  .object({
    bicAmount: z
      .union([
        z
          .number({
            invalid_type_error: zodLocales.errors.amount,
          })
          .nonnegative(zodLocales.errors.positive),
        z.nan(),
      ])
      .nullable(),
    bncAmount: z
      .union([
        z
          .number({
            invalid_type_error: zodLocales.errors.amount,
          })
          .nonnegative(zodLocales.errors.positive),
        z.nan(),
      ])
      .nullable(),
    complementaryRevenue: z.union([z.number(), z.nan()]).nullable(),
    isMixedActivityChecked: z.boolean(),
    revenue: z.number().nonnegative(zodLocales.errors.positive),
    sellingAmount: z
      .union([
        z
          .number({
            invalid_type_error: zodLocales.errors.amount,
          })
          .nonnegative(zodLocales.errors.positive),
        z.nan(),
      ])
      .nullable(),
  })
  .superRefine((data, ctx) => {
    if (!data.isMixedActivityChecked) {
      return;
    }

    const totalDistribution =
      (data.bicAmount || 0) + (data.bncAmount || 0) + (data.sellingAmount || 0);
    const totalRevenue = data.revenue + (data.complementaryRevenue || 0);

    if (totalDistribution !== totalRevenue) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: locales.form.distributionAmounts,
        path: ['bicAmount'],
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: locales.form.distributionAmounts,
        path: ['bncAmount'],
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: locales.form.distributionAmounts,
        path: ['sellingAmount'],
      });
    }
  });

export type RevenueSituationSchema = z.infer<typeof revenueSituationSchema>;
